import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { useOrdersList } from "../../context/OrderListContext";
import OrdersListFiltersWeb from "./layouts/OrdersListFilters.web";
import OrdersListFiltersMob from "./layouts/OrdersListFilters.mob";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";


const OrderListFiltersComponent = withConditionalComponent(OrdersListFiltersWeb,OrdersListFiltersMob);

export default function OrdersListFilters() {
  const { dateRange, setDateRange } = useOrdersList();
  const [from, to] = dateRange;
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  
  return (
    <OrderListFiltersComponent props={{from, to, setDateRange}} trigger={isLargeScreen}/>
  );
}
